import * as React from "react";
export function Checkbox(props: React.InputHTMLAttributes<HTMLInputElement>) {
    return <input type="checkbox" {...props} style={{ width: 16, height: 16, accentColor: "#1ea6ff" }} />;
}
